// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__KqXG3","container_light":"Layout_container_light__o+EDl"};